export default __webpack_public_path__ + "static/media/arrow-card.a82b0319.svg";